import { MqttCommandForm } from './steps/MqttCommandForm';
import { RecordMeasurementForm } from './steps/RecordMeasurementForm';
import { WaitDurationForm } from './steps/WaitDurationForm';
import { inferStepType } from '../types/steps';
import type {
  CommandStep,
  ScriptStep,
  ScriptStepWithId,
  TestPointRef,
  WaitStep,
  MeasureStep
} from '../types/steps';

type Props = {
  step: ScriptStepWithId;
  testPointRef?: TestPointRef | null;
  onUpdate: (id: string, updates: Partial<ScriptStep>) => void;
};

export const StepForm = ({ step, testPointRef, onUpdate }: Props) => {
  const handleChange = (updates: Partial<ScriptStep>) => {
    onUpdate(step.id, updates);
  };

  const effectiveType = inferStepType(step as Record<string, unknown>);

  switch (effectiveType) {
    case 'command':
      return (
        <MqttCommandForm
          step={step as CommandStep & { id: string; index: number }}
          testPointRef={testPointRef}
          onChange={handleChange}
        />
      );
    case 'measure':
    case 'get_result_and_pic':
      return (
        <RecordMeasurementForm
          step={step as MeasureStep}
          onChange={handleChange}
        />
      );
    case 'wait':
      return (
        <WaitDurationForm step={step as WaitStep} onChange={handleChange} />
      );
    default:
      return null;
  }
};
